/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunColorListDTO
 */
export interface RunColorListDTO {
    /**
     * 
     * @type {string}
     * @memberof RunColorListDTO
     */
    createdBy: string;
    /**
     * 
     * @type {Date}
     * @memberof RunColorListDTO
     */
    createdTime: Date;
    /**
     * 
     * @type {string}
     * @memberof RunColorListDTO
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof RunColorListDTO
     */
    lastUpdatedTime: Date;
    /**
     * 
     * @type {string}
     * @memberof RunColorListDTO
     */
    name: string;
}

/**
 * Check if a given object implements the RunColorListDTO interface.
 */
export function instanceOfRunColorListDTO(value: object): value is RunColorListDTO {
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lastUpdatedTime' in value) || value['lastUpdatedTime'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function RunColorListDTOFromJSON(json: any): RunColorListDTO {
    return RunColorListDTOFromJSONTyped(json, false);
}

export function RunColorListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunColorListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'createdBy': json['createdBy'],
        'createdTime': (new Date(json['createdTime'])),
        'id': json['id'],
        'lastUpdatedTime': (new Date(json['lastUpdatedTime'])),
        'name': json['name'],
    };
}

export function RunColorListDTOToJSON(value?: RunColorListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdBy': value['createdBy'],
        'createdTime': ((value['createdTime']).toISOString()),
        'id': value['id'],
        'lastUpdatedTime': ((value['lastUpdatedTime']).toISOString()),
        'name': value['name'],
    };
}

